/* ============================================================
   PRODUCT PAGE ONLY GUARD
============================================================ */

const IS_PDP = document.body.classList.contains('template-product');

if (IS_PDP) {

  /* ============================================================
     VARIANT UTILITIES
  ============================================================ */

  function getVariantSelects() {
    return document.querySelector('main variant-selects');
  }

  function allVariantOptionsSelected() {
    const variantSelects = getVariantSelects();
    if (!variantSelects) return true;

    const fieldsets = variantSelects.querySelectorAll('fieldset');
    if (!fieldsets.length) return true;

    for (const fieldset of fieldsets) {
      const checked = fieldset.querySelector(
        'input[type="radio"]:checked, select option:checked:not([value=""])'
      );
      if (!checked) return false;
    }
    return true;
  }

  /* ============================================================
     INITIAL VISUAL RESET (RADIO SWATCHES)
  ============================================================ */

  document.addEventListener('DOMContentLoaded', () => {
    const variantSelects = getVariantSelects();
    if (!variantSelects) return;

    variantSelects.querySelectorAll('input[type="radio"]').forEach(input => {
      input.checked = false; // visual only
    });

    variantSelects.querySelectorAll('label').forEach(label => {
      label.classList.remove('is-active');
    });
  });

  /* ============================================================
     VARIANT CHANGE HANDLING
  ============================================================ */

  document.addEventListener('change', (e) => {
    const variantSelects = e.target.closest('main variant-selects');
    if (!variantSelects) return;

    const input = e.target;

    // Restore visual state for radio swatches
    if (input.type === 'radio') {
      const fieldset = input.closest('fieldset');
      if (fieldset) {
        fieldset.querySelectorAll('label').forEach(label =>
          label.classList.remove('is-active')
        );
        const activeLabel = fieldset.querySelector(`label[for="${input.id}"]`);
        if (activeLabel) activeLabel.classList.add('is-active');
      }
    }

    if (allVariantOptionsSelected()) {
      removeVariantError();
    }

  });

  /* ============================================================
     ERROR UI (DAWN STYLE)
  ============================================================ */

  function showVariantError() {
    const variantSelects = getVariantSelects();
    if (!variantSelects) return;

    let wrapper = document.getElementById('variant-error-wrapper');

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.id = 'variant-error-wrapper';
      wrapper.className = 'product-form__error-message-wrapper';

      const error = document.createElement('span');
      error.className = 'product-form__error-message';
      error.textContent = 'Please select all options before adding to cart.';

      wrapper.appendChild(error);
      variantSelects.appendChild(wrapper);
    }

    wrapper.removeAttribute('hidden');

    variantSelects.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  function removeVariantError() {
    const wrapper = document.getElementById('variant-error-wrapper');
    if (wrapper) wrapper.setAttribute('hidden', true);
  }

  /* ============================================================
     PRODUCT FORM (BLOCK PDP ONLY)
  ============================================================ */

  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          // Skip quick add modal
          if (this.closest('quick-add-modal')) return;

          this.form = this.querySelector('form');
          this.variantIdInput.disabled = false;

          this.form.addEventListener(
            'submit',
            this.onSubmitHandler.bind(this)
          );

          this.cart =
            document.querySelector('cart-notification') ||
            document.querySelector('cart-drawer');

          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector('span');

          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }

          this.hideErrors = this.dataset.hideErrors === 'true';
        }

        onSubmitHandler(evt) {
          evt.preventDefault();

          //  BLOCK ADD TO CART UNTIL ALL OPTIONS SELECTED
          if (!allVariantOptionsSelected()) {
            showVariantError();
            return;
          }

          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map(section => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(response => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                this.error = true;
                return;
              }

              this.error = false;
              if (this.cart && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(response);
              } else {
                window.location.href = window.routes.cart_url;
              }

            })
            .catch(console.error)
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (!this.error)
                this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
        }

        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector('.product-form__error-message-wrapper');

          if (!this.errorMessageWrapper) return;

          this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              '.product-form__error-message'
            );

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
            toggleSubmitButton(disable = true, text) {
        if (disable) {
          if(typeof this.submitButton == 'undefined'){
            
            const quickAddModals = document.querySelectorAll('quick-add-modal');

            quickAddModals.forEach(modal => {
              
              let submitButton = modal.shadowRoot
                ? modal.shadowRoot.querySelector('.product-form__submit')
                : modal.querySelector('.product-form__submit');

              if (submitButton) {
                submitButton.setAttribute('disabled', 'disabled');
              }
            });
          }else{
            this.submitButton.setAttribute('disabled', 'disabled');
             if (text) this.submitButtonText.textContent = text;
          }
         
        } else {
          if(typeof this.submitButton == 'undefined'){
            const quickAddModals = document.querySelectorAll('quick-add-modal');

                    quickAddModals.forEach(modal => {
                      let submitButton = modal.shadowRoot
                        ? modal.shadowRoot.querySelector('.product-form__submit')
                        : modal.querySelector('.product-form__submit');

                      if (submitButton) {
                        submitButton.removeAttribute('disabled');
                      }
                    });
          }else{
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
   
        }
              // ---------- New code: sync sticky dropdown ----------
          let variantSelects = document.getElementsByTagName('variant-selects');
            if (!variantSelects) return;
          variantSelects = variantSelects[0];
          const stickySelect = document.querySelector('#md-sticky-atc select[name="id"]');
          if (stickySelect) {
            const selectedVariantScript = variantSelects.querySelector('script[data-selected-variant]');
            if (selectedVariantScript) {
              const variant = JSON.parse(selectedVariantScript.textContent);
              stickySelect.value = variant.id;
              stickySelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

      }
        get variantIdInput() {
          return this.form.querySelector('[name=id]');
        }
      }
    );
  }

  /* ============================================================
     SHOP PAY / EXPRESS CHECKOUT BLOCK (PDP ONLY)
  ============================================================ */

  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest(
        'shop-pay-wallet-button, .shopify-payment-button__button'
      );

      if (!btn) return;
      if (btn.closest('quick-add-modal')) return;

      if (!allVariantOptionsSelected()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showVariantError();
      }
    },
    true // capture phase
  );
}else{
  if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

}
